export default "__VITE_ASSET__D7ISjhSc__"